/* StudioSoie · page panier (sections/ss-cart-page.liquid). Chargé en defer par layout/theme.liquid sur le modèle « cart ».
   Quantités, suppression, compagnons et code promo passent par l'Ajax API avec « sections » : la section est
   rendue côté serveur et remplacée d'un bloc (pas de logique de prix côté client). Booster écoute fetch() et
   rafraîchit le compteur de l'en-tête et le tiroir tout seul. Vanilla, ES5, sans dépendance. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function sectionId() { var r = q('[data-ssc-root]'); return r ? r.getAttribute('data-section-id') : null; }

  /* Remplace la section par le HTML rendu (réponse « sections » de l'Ajax API ou /cart?section_id=) */
  function swap(html) {
    var root0 = q('[data-ssc-root]'); if (!root0 || !html) { return; }
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var next = q('[data-ssc-root]', tmp); if (!next) { return; }
    var section = root0.closest('.shopify-section') || root0.parentNode;
    var active = document.activeElement, focusKey = null, focusSel = null;
    if (active && section.contains(active)) {
      focusKey = active.getAttribute('data-key');
      focusSel = active.hasAttribute('data-ssc-qty-input') ? '[data-ssc-qty-input]' : (active.hasAttribute('data-ssc-qty') ? '[data-ssc-qty][data-delta="' + active.getAttribute('data-delta') + '"]' : null);
    }
    root0.parentNode.replaceChild(next, root0);
    if (focusKey && focusSel) { var f = q(focusSel + '[data-key="' + focusKey + '"]'); if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } } }
    document.dispatchEvent(new CustomEvent('ss:cart:rendered'));
  }
  function busy(on) { var r = q('[data-ssc-root]'); if (r) { r.classList.toggle('is-busy', !!on); r.setAttribute('aria-busy', on ? 'true' : 'false'); } }
  function refetch() {
    return fetch(root + 'cart?section_id=' + encodeURIComponent(sectionId()), { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
      .then(function (r) { return r.text(); }).then(swap);
  }
  window.SSC_REFETCH = function () { if (sectionId()) { return refetch(); } };
  function post(path, body) {
    var sid = sectionId();
    if (sid) { body.sections = sid; body.sections_url = root + 'cart'; }
    busy(true);
    return fetch(root + path, { method: 'POST', headers: H, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }, function () { return { ok: false, json: null }; }); })
      .then(function (res) {
        if (res.ok && res.json && res.json.sections && sid && res.json.sections[sid]) { swap(res.json.sections[sid]); }
        else { return refetch().then(function () { return res; }); }
        return res;
      })
      .catch(function () { return refetch(); })
      .then(function (res) { busy(false); return res; });
  }
  function toast(msg, kind) {
    var el = q('[data-ssc-toast]');
    if (!el) { el = document.createElement('div'); el.className = 'ssc-toast'; el.setAttribute('data-ssc-toast', ''); el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.className = 'ssc-toast is-on' + (kind ? ' ssc-toast--' + kind : '');
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---- quantités ---- */
  var qtyTimer = null;
  function changeQty(key, qty) {
    if (qty < 0) { qty = 0; }
    return post('cart/change.js', { id: key, quantity: qty }).then(function (res) {
      if (res && res.json && res.json.status && res.json.description) { toast(res.json.description, 'error'); }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ssc-qty]');
    if (b) {
      e.preventDefault();
      var line = b.closest('[data-ssc-line]'), input = line && q('[data-ssc-qty-input]', line);
      if (!input) { return; }
      var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-delta'), 10);
      var max = parseInt(input.getAttribute('max'), 10);
      if (!isNaN(max) && v > max) { v = max; }
      input.value = v;
      changeQty(b.getAttribute('data-key'), v);
      return;
    }
    var rm = e.target.closest('[data-ssc-remove]');
    if (rm) { e.preventDefault(); var l = rm.closest('[data-ssc-line]'); if (l) { l.classList.add('is-removing'); } changeQty(rm.getAttribute('data-key'), 0); return; }

    var add = e.target.closest('[data-ssc-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('.ssc-up'), sel = card && q('[data-ssc-up-variant]', card);
      var id = parseInt((sel && sel.value) || add.getAttribute('data-variant'), 10);
      if (!id) { return; }
      add.disabled = true;
      post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function (res) {
        if (res && res.json && res.json.status && res.json.description) { toast(res.json.description, 'error'); add.disabled = false; }
      });
      return;
    }

    var apply = e.target.closest('[data-ssc-discount-apply]');
    if (apply) { e.preventDefault(); applyDiscount(); return; }
    var rmc = e.target.closest('[data-ssc-discount-remove]');
    if (rmc) { e.preventDefault(); removeDiscount(rmc.getAttribute('data-code')); }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-ssc-qty-input]');
    if (!input) { return; }
    clearTimeout(qtyTimer);
    var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) { v = 0; }
    var max = parseInt(input.getAttribute('max'), 10); if (!isNaN(max) && v > max) { v = max; input.value = v; }
    qtyTimer = setTimeout(function () { changeQty(input.getAttribute('data-key'), v); }, 150);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('[data-ssc-qty-input]')) { e.preventDefault(); e.target.blur(); }
    if (e.key === 'Enter' && e.target.closest('[data-ssc-discount-input]')) { e.preventDefault(); applyDiscount(); }
  });

  /* ---- code promo : cart/update.js { discount } quand la boutique le permet, sinon /discount/CODE (cookie, appliqué au paiement) ---- */
  function discountStatus(msg, ok) { var s = q('[data-ssc-discount-status]'); if (s) { s.textContent = msg || ''; s.classList.toggle('is-ok', !!ok); s.classList.toggle('is-error', !ok && !!msg); } }
  function applyDiscount() {
    var input = q('[data-ssc-discount-input]'); if (!input) { return; }
    var code = (input.value || '').trim().toUpperCase(); if (!code) { input.focus(); return; }
    var rootEl = q('[data-ssc-root]');
    var tInvalid = (rootEl && rootEl.getAttribute('data-t-invalid')) || 'Code non valable', tApplied = (rootEl && rootEl.getAttribute('data-t-applied')) || 'Code appliqué';
    busy(true);
    fetch(root + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ discount: code }) })
      .then(function (r) { if (!r.ok) { throw new Error('cart ' + r.status); } return r.json(); })
      .then(function (cart) {
        var codes = cart && cart.discount_codes;
        if (Array.isArray(codes)) {
          var hit = null;
          for (var i = 0; i < codes.length; i++) { if (String(codes[i].code).toUpperCase() === code) { hit = codes[i]; } }
          if (hit && hit.applicable) { discountStatus(tApplied, true); input.value = ''; return refetch(); }
          discountStatus(tInvalid, false); busy(false);
          if (hit && !hit.applicable) { return fetch(root + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ discount: '' }) }); }
          return null;
        }
        /* API sans prise en charge des codes : cookie de réduction puis retour sur le panier */
        window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
        return null;
      })
      .catch(function () { window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart'); });
  }
  function removeDiscount(code) {
    var rootEl = q('[data-ssc-root]'); busy(true);
    fetch(root + 'cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ discount: '' }) })
      .then(function () { return refetch(); }).then(function () { busy(false); discountStatus(''); })
      .catch(function () { busy(false); });
    void rootEl; void code;
  }

  /* ---- message cadeau : la note est aussi gérée par ss-theme.js (débounce) ; ici on re-lie après chaque rendu ---- */
  document.addEventListener('ss:cart:rendered', function () {
    document.dispatchEvent(new CustomEvent('booster:content:update', { detail: { trigger: 'ss-cart' } }));
    if (window.SS_RV && typeof window.SS_RV.render === 'function') { window.SS_RV.render(); }
  });

  /* Sans JavaScript : le formulaire /cart met à jour les quantités ; avec : Enter dans une quantité ne soumet pas le formulaire */
  var form = q('[data-ssc-form]');
  if (form) { form.addEventListener('submit', function (e) { var sub = e.submitter; if (sub && sub.name === 'checkout') { return; } if (!sub) { e.preventDefault(); } }); }
})();
